import React, { useState } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";
import PropagateLoader from "react-spinners/PropagateLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import "./Weather.css";
import "./Navigation.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    setWeatherData({
      ready: true,
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      city: response.data.name,
      country: response.data.sys.country,
      humidity: response.data.main.humidity,
      description: response.data.weather[0].main,
      tempMax: response.data.main.temp_max,
      tempMin: response.data.main.temp_min,
      date: new Date(response.data.dt * 1000),
      icon: response.data.weather[0].icon,
      coord: response.data.coord,
    });
  }
  function search() {
    let apiKey = `677a0d74bb153df8022c5d432026b13a`;
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search(city);
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Tag">
        <div className="Navigation">
          <form onSubmit={handleSubmit} className="d-flex">
            <input
              className="form-control me-2"
              type="search"
              placeholder="Change City"
              aria-label="Search"
              onChange={handleCityChange}
            />
            <button className="btn search-button" type="submit">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>
          </form>
        </div>
        <div className="Weather">
          <WeatherInfo data={weatherData} />
        </div>
        <h2>In the next 5 days</h2>
        <Forecast coord={weatherData.coord} />
      </div>
    );
  } else {
    search();
    return <PropagateLoader color="rgba(77, 107, 226, 0.699)" size={15} />;
  }
}
